module.exports = __webpack_public_path__ + "static/media/portfolio1 (12).d2987051.jpeg";